(function() {
    'use strict';

    angular
        .module('adjustBenApp')
        .controller('CustomerInfoPopupController', CustomerInfoPopupController);

    CustomerInfoPopupController.$inject = ['$scope', '$state', 'NgTableParams', 'FORMAT_DATE', 'CustomerInfoService', '$uibModalInstance','vmClient','$base64'];

    function CustomerInfoPopupController ($scope, $state, NgTableParams, FORMAT_DATE,  CustomerInfoService, $uibModalInstance, vmClient, $base64) {
    	var vm = this;
    	vm.client = vmClient;
    	vm.genderTypes = genderTypes;
    	vm.clientRoleTypes =clientRoleTypes;
    	vm.cancel = function() {
			$uibModalInstance.dismiss('cancel');
		};
		CustomerInfoService.query({uri:'getCustomerContract', clientCode : vm.client.clientCode}, function(result){
			vm.vwClientPolicies = result;
		});

	    vm.getItem = function (array, code) {
	        var obj = array.filter(function (val) {
	            return val.code === code;
	        });

	        // Filter returns an array, and we just want the matching item.
	        return obj[0].name;
	    }
	    vm.encode = function(code){
	    	return $base64.encode(code);
	    }
    }
})();
